import { Col, Image, Row } from "react-bootstrap"
import synapseReconstruction from "../images/tools/iascone.jpg"
import calciumImaging from "../images/tools/calciumImaging.png"
import rabiesTracing from "../images/tools/rabies1.png"
import vaa3d from "../images/tools/vaa3dTrace.png"
import rois from "../images/tools/srgap2cCalcium.png"
import rabiesTracing2 from "../images/tools/rabies2.png"
import React, { useState } from "react"
import { GoLinkExternal } from "react-icons/go"

export default function Tools() {
  //const [isShown, setIsShown] = useState(false)
  //const [isShown2, setIsShown2] = useState(false)
  //const [isShown3, setIsShown3] = useState(false)

  return (
    <div style={{ paddingTop: 20 }}>
      <Row xs={1} md={2} lg={2} className="researchRow">
        <Col xs={12} md={6} className="toolCol">
          <div style={{ maxWidth: "500px", alignSelf: "center" }}>
            <h1 className="toolTitle">
              In Utero Electroporation and Neuron Reconstruction
            </h1>
            <div className="toolText">
              <div style={{ paddingTop: 20 }}>
                We developed a new, open-source, reconstruction platform for
                mapping the size and spatial distribution of E and I synapses
                received by individual, genetically-labeled, layer 2/3 cortical
                pyramidal neurons (PNs) in vivo. We mapped over 90,000 E and I
                synapses across twelve L2/3 PNs and uncovered structured
                organization of E and I synapses across dendritic domains as
                well as within individual dendritic segments in these cells.
                <br/>
                The image describes the workflow for excitatory and inhibitory
                synaptic reconstruction across whole neurons with Vaa3D Synapse
                Detector program developed in collaboration with the Allen
                Institute for Brain Science.
              </div>
            </div>
            <div className="toolFeatured">
              This work is featured in{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.cell.com/neuron/pdf/S0896-6273(20)30138-0.pdf"
                className="toolLink"
              >
                this paper by Daniel Iascone{" "}
              </a>
            </div>
          </div>
        </Col>
        <Col
          xs={12}
          md={6}
          className="toolCol"
          //onMouseEnter={() => setIsShown(true)}
          //onMouseLeave={() => setIsShown(false)}
        >
          {// {isShown === false && (
          }
          <Image src={synapseReconstruction} className="toolsImage"/>
          {/*})
          { isShown === true && <Image src={vaa3d} className="toolsImage" />}
          */}
        </Col>
      </Row>
      <div className="separator"/>
      <div style={{ paddingTop: 30 }}>
        <Row xs={1} md={2} lg={2} className="researchRow">
          <Col xs={12} md={6} className="toolCol">
            <div style={{ maxWidth: "500px", alignSelf: "center" }}>
              <h1 className="toolTitle">
                Rabies Tracing and Neural Connectivity Reconstruction
              </h1>
              <div className="toolText">
                <div style={{ paddingTop: 20 }}>
                  <div style={{ paddingBottom: 20 }}>
                    We have adapted monosynaptic pseudo-rabies tracing to quantitatively map the inputs received by
                    specific pyramidal neurons in the mouse cortex using combination of sparse in utero cortical
                    electroporation (IUCE) using a Cre- dependent expression FLEX-plasmid expressing TVA receptor, N2c
                    Glycoprotein, and histone- tagged-GFP (hGFP). TVA expression enables infection by EnvA pseudotyped
                    G-deleted N2c rabies virus (Rabv), while the N2c glycoprotein is required for trans- synaptic and
                    retrograde spread of the virus. Hence, sparse Cre-induced expression of hGFP, TVA and N2c in a
                    sparse population of layer 2/3 pyramidal neurons primes these ‘starter’ neurons for infection and
                    trans- synaptic labeling by the pseudotype. Ewoud Schmidt in our lab also developed a computational
                    pipeline to map the 3D position of all traced neurons from multiple mouse brains in a common
                    reference Atlas (Allen Brain Atlas).
                  </div>
                </div>
              </div>
              <div className="toolFeatured">
                This work is featured in
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.biorxiv.org/content/10.1101/852970v1"
                  className="toolLink"
                >
                  <> </>
                  this paper by Ewoud Schmidt
                </a>
                .
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            className="toolCol"
            //onMouseEnter={() => setIsShown2(true)}
            //onMouseLeave={() => setIsShown2(false)}
          >
            {// {isShown2 === false && (
            }
            <Image src={rabiesTracing} className="toolsImage"/>
            {/*})}
            {isShown2 === true && (
              <Image src={rabiesTracing2} className="toolsImage" />
            )}
            */}
          </Col>
        </Row>
      </div>
      <div className="separator"/>
      <div style={{ paddingTop: 30 }}>
        <Row xs={1} md={2} lg={2} className="researchRow">
          <Col xs={12} md={6} className="toolCol">
            <div style={{ maxWidth: "500px", alignSelf: "center" }}>
              <h1 className="toolTitle">
                2-Photon Calcium Imaging in awake behaving mice
              </h1>
              <div className="toolText">
                <div style={{ paddingTop: 20 }}>
                  We implemented in vivo 2-photon (2P) Ca2+ imaging in awake behaving mice to probe either in cortical
                  or hippocampal circuit function. For example, in close collaboration with our colleague in{" "}
                  <>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.losonczylab.org/"
                      className="toolLink"
                    >
                      Attila Losonczy's lab
                    </a>{" "}
                  </>
                  , Heike Blockus has used this approach to probe changes in the response properties of control or
                  Robo2-deficient in hippocampal CA1 pyramidal neurons in the same mice. She found that reduction by 40%
                  of inputs from CA3 in Robo2-deficient CA1 PNs significantly alters the fraction of spatially tuned CA1
                  PNs and alters spatial coding. Ewoud Schmidt in our lab also used in vivo 2-photon Ca2+ imaging to
                  demonstrate that humanization of SRGAP2C expression in layer 2/3 of the barrel cortex increases the
                  reliability and selectivity of sensory evoked responses.
                </div>
              </div>
              <div className="toolFeatured">
                This work is featured in the latest papers of
                <> </>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.biorxiv.org/content/10.1101/852970v1"
                  className="toolLink"
                >
                  Ewoud Schmidt
                </a>
                <> </>
                and
                <> </>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.biorxiv.org/content/10.1101/840710v1"
                  className="toolLink"
                >
                  Heike Blockus
                </a>
                .
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            className="toolCol"
            //onMouseEnter={() => setIsShown3(true)}
            //onMouseLeave={() => setIsShown3(false)}
          >
            {//{isShown3 === false && (
            }
            <Image
              src={calciumImaging}
              className="toolsImage"
              style={{ width: 500, height: 400 }}
            />
            {/*
            } )}
            {isShown3 === true && (
              <Image
                src={rois}
                className="toolsImage"
                style={{ width: 500, height: 400 }}
              />
            )}
            */}
          </Col>
        </Row>

      </div>
    </div>
  )
}
